import React, { useState } from "react";
import clienteAxios from "../../axios"; // Asegúrate de que esta sea la ruta correcta

const ModalAgregarPersonalCocina = ({ show, onClose, cocinaId, onPersonalAgregado }) => {
    const [nuevoPersonal, setNuevoPersonal] = useState({
        empleado_id: "",
        rol: ""
    });

    const handleAgregarPersonalCocina = async (e) => {
        e.preventDefault();
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Agregar",
                modulo: "personal_cocina",
                cocina_id: cocinaId,  // Relacionamos el nuevo personal con la cocina
                empleado_id: nuevoPersonal.empleado_id,  // ID del empleado que ya debe existir
                rol: nuevoPersonal.rol  // Rol del personal dentro de la cocina
            });
            setNuevoPersonal({ empleado_id: "", rol: "" });
            onPersonalAgregado();  // Actualizamos la lista después de agregar
            onClose();  // Cerramos el modal
        } catch (error) {
            console.log(error);
        }
    };

    if (!show) {
        return null;  // No renderizamos el modal si show es false
    }

    return (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-6 rounded-lg">
                <h2 className="text-lg font-semibold mb-4">Agregar Nuevo Personal a Cocina</h2>
                <form onSubmit={handleAgregarPersonalCocina}>
                    <input
                        type="number"
                        placeholder="ID del Empleado"
                        value={nuevoPersonal.empleado_id}
                        onChange={(e) => setNuevoPersonal({ ...nuevoPersonal, empleado_id: e.target.value })}
                        className="border rounded-lg p-2 mb-2 w-full"
                        maxLength={10}
                    />
                    <input
                        type="text"
                        placeholder="Rol"
                        value={nuevoPersonal.rol}
                        onChange={(e) => setNuevoPersonal({ ...nuevoPersonal, rol: e.target.value })}
                        className="border rounded-lg p-2 mb-4 w-full"
                        maxLength={30}
                    />
                    <button type="submit" className="bg-green-500 text-white px-4 py-2 rounded mr-2">
                        Agregar Personal
                    </button>
                    <button type="button" onClick={onClose} className="bg-gray-500 text-white px-4 py-2 rounded">
                        Cancelar
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ModalAgregarPersonalCocina;
